import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "@/contexts/CartContext";
import { WishlistProvider } from "@/contexts/WishlistContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Looks from "@/pages/Looks";
import LookDetail from "@/pages/LookDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Wishlist from "@/pages/Wishlist";
import Admin from "@/pages/Admin";
import SizeGuide from "@/pages/SizeGuide";
import { Privacy, Terms, FAQ, Shipping, Returns } from "@/pages/InfoPages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <CartProvider>
          <WishlistProvider>
            <AnnouncementBar />
            <Nav />
            <CartDrawer />
            <main className="relative z-10">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/looks" element={<Looks />} />
                <Route path="/looks/:slug" element={<LookDetail />} />
                <Route path="/shop" element={<Looks />} />
                <Route path="/new-in" element={<Looks />} />
                <Route path="/mood/:mood" element={<Looks />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/size-guide" element={<SizeGuide />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/shipping" element={<Shipping />} />
                <Route path="/returns" element={<Returns />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" theme="light" toastOptions={{
              style: { background: "#FDFBF7", border: "1px solid #EBE5ED", color: "#4A464A", fontFamily: "Manrope" }
            }} />
          </WishlistProvider>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}
